import BgVideo from "../assets/share.mp4";
import logo from "../assets/logowhite.png";
import { GoogleLogin } from 'react-google-login';
import { useNavigate } from "react-router-dom";
import { gapi } from "gapi-script";
import {client} from "../client";
import {useEffect} from "react";

const Login = () => {
    const navigate = useNavigate();
    useEffect(() => {
        const anyUser = localStorage.getItem('user');
        if (anyUser) navigate('/',{ replace: true });
    },[]);
    const responseGoogle = (response) => {
        localStorage.setItem('user',JSON.stringify(response.profileObj));
        const { googleId,name,imageUrl } = response.profileObj;
        const userDoc = {
            _id: googleId,
            _type: "user",
            userName: name,
            image: imageUrl,
        };
        client.createIfNotExists(userDoc).then(() => {
            navigate('/',{ replace: true });
        });
    }
    window.gapi.load('client:auth2', () => {
        window.gapi.client.init({
            clientId: 'your client id will be display here',
            plugin_name: "chat"
        })
    })
    return (
        <div className="w-full h-full h-screen relative">
            <video src={BgVideo} loop controls={false} autoPlay muted type="video/mp4" className="w-full h-full object-cover"></video>
            <div className="absolute flex flex-col justify-center items-center top-0 bottom-0 left-0 right-0 bg-blackOverlay">
                <div className="p-5"><img src={logo} alt="..." width="130"/></div>
                <div className="shadow">
                    <GoogleLogin
                        clientId={process.env.REACT_APP_GOOGLE_API_TOKEN}
                        buttonText="Login With Google"
                        onSuccess={responseGoogle}
                        onFailure={responseGoogle}
                        cookiePolicy={'single_host_origin'}
                    />
                </div>
            </div>
        </div>
    )
};

export default Login;